import React, { Component, ErrorInfo, ReactNode } from 'react'

interface Props {
	children: ReactNode
}

interface State {
	hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
	public state: State = {
		hasError: false,
	}

	public static getDerivedStateFromError(_: Error): State {
		// Update state so the next render will show the fallback UI.
		return { hasError: true }
	}

	public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error('Uncaught error:', error, errorInfo)
	}

	public render() {
		if (this.state.hasError) {
			return (
				<div className="tt-flex tt-flex-col tt-gap-8 tt-text-center tt-items-center tt-justify-center tt-w-full">
					<div className="tt-text-14 tt-font-bold">Произошла ошибка</div>
				</div>
			)
		}

		return this.props.children
	}
}

export default ErrorBoundary
